export default __webpack_public_path__ + "static/media/rounded-zone-selection.421794ed.svg";